// extracted by mini-css-extract-plugin
module.exports = {"popover":"access-token-popover_popover__CPeMS","token-row":"access-token-popover_token-row__L68UE"};